//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardSectionProperties from '../../components/Card/CardSectionProperties.vue'
import DateIntervalField from '../../components/Field/DateIntervalField.vue'

export default {
  name: 'EmployeeSectionSkud',
  components: {
    CardSectionProperties,
    DateIntervalField
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      mode: null, // 'last', 'interval'
      intervalConfig: { start: null, end: null }
    }
  },
  created: function () {
    this.prepareSection()
  },
  methods: {
    onChangeInterval: function () {
      if (this.intervalConfig.start && this.intervalConfig.end) {
        if (this.mode !== 'interval') {
          this.mode = 'interval'
        }
        this.setSkudHistoryInterval({
          startTime: this.intervalConfig.start,
          endTime: this.intervalConfig.end
        })
      }
    },
    onResetInterval: function () {
      if (this.mode !== 'last') {
        this.mode = 'last'

        this.setIntervalFieldValue(null)
        this.setSkudHistoryInterval(null)
      }
    },
    setIntervalFieldValue: function (interval) {
      if (interval && interval.startTime && interval.endTime) {
        this.intervalConfig.start = interval.startTime
        this.intervalConfig.end = interval.endTime
      } else {
        this.intervalConfig.start = null
        this.intervalConfig.end = null
      }
    },
    setSkudHistoryInterval: function (interval) {
      const skudHistoryProps = this.getSkudHistoryCmpProps()
      if (skudHistoryProps) {
        skudHistoryProps.interval = interval
      }
    },
    getSkudHistoryCmpProps: function () {
      const props = this.config.props
      if (props) {
        const skudHistoryConfig = props.find(prop => prop.key === 'skudHistory')
        return skudHistoryConfig && skudHistoryConfig.componentProps
      }
    },
    parseDate (value) {
      const pattern = /(\d{2}).(\d{2}).(\d{4})/
      return new Date(value.replace(pattern, '$3-$2-$1T00:00:00'))
    },

    // @Override
    prepareSection: function () {
      const skudHistoryProps = this.getSkudHistoryCmpProps()
      if (skudHistoryProps && skudHistoryProps.interval) {
        this.setIntervalFieldValue(skudHistoryProps.interval)
        this.mode = 'interval'
      } else {
        this.setIntervalFieldValue(null)
        this.mode = 'last'
      }
    }
  }
}
